import {
  BulletinReport,
  ChartData,
  TopVisitData,
  TopMenuData,
  Export,
  AccessRateChartsData,
} from '@/domain/entities/BulletinReport'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class BulletinReportDataMapper extends BaseResponseMapper {
  public convertBulletinReportFromApi(
    result: AxiosResponse<any>
  ): BulletinReport {
    const { data } = result
    return new BulletinReport(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (menu) =>
          new TopMenuData(menu.id, menu.name, menu.key, menu.value, menu.color)
      ),
      data.data.charts.items.map(
        (chart) => new ChartData(chart.period, chart.total)
      ),
      data.data.monthly_access_charts
        ? data.data.monthly_access_charts.items.map(
            (val) =>
              new AccessRateChartsData(
                val.month,
                val.percentage,
                val.total_user_access,
                val.total_user_visit
              )
          )
        : [],
      data.data.top_visit.items.map(
        (user) =>
          new TopVisitData(
            user.id,
            user.title,
            user.total_user,
            user.total_visit,
            user.created_date,
            user.file_code
          )
      )
    )
  }
  public convertExportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Export(data.success, data.message, data.data)
  }
}
